import { getPanelOptions } from '../utils';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';

export default {
    sections: ['details'],
    toolbar: ['add', 'edit', 'active', 'delete'],
    fields: {
        type: {
            noTitle: true,
            section: 'details',
            label: 'Panel type',
            readonly: true,
            position: 0,
            section: 'details',
            component: RadioListComponent,
            values: function (value) {
                return getPanelOptions([value]);
            },
        },
        name: {
            section: 'details',
            position: 1,
        },
        // form_type: {
        //     section: 'details',
        //     position: 2,
        // },
        template: {
            section: 'details',
            position: 2,
        },
        description: {
            section: 'details',
            position: 3,
        },
        content: {
            section: 'details',
            position: 4,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.panel-form.js